import {
  TableContainer,
  TableHead,
  TableBody,
  withWidth,
} from "@material-ui/core";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { StyledFAB } from "../../components/CustomStyles/CustomFAB";
import BootstrapInputSearch from "../../components/InputSearch/BootstrapInputSearch";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import IzyTabsPanel from "../../components/IzyTabsPanel";
import DateRangePickerFilter from "../../components/Filters/DateRangePicker";
import moment from "moment-timezone";
import {
  IZYTable,
  IZYTableCell,
  IZYTableRow,
} from "../../components/CustomStyles/CustomTable";
import { useQuery } from "react-query";
import { handleError } from "../../components/Utils/Utils";
import { ListRowPanel, ListRowLoadingPanel } from "./parts/NewListPanel";
import TransactionDeliveryService from "../../Services/TransactionDelivery";
import FormStartDelivery from "./parts/FormStartDelivery";
import FormCompleteDelivery from "./parts/FormCompleteDelivery";

const NewOrder = ({ width, params }) => {
  const [arrStatus, setArrStatus] = React.useState([
    {
      status: "waiting",
      sub_title: 0,
      title: "Waiting Pickup",
      active: false,
    },
    {
      status: "process",
      sub_title: 0,
      title: "On Delivery",
      active: false,
    },
    {
      status: "complete",
      sub_title: 0,
      title: "Complete",
      active: false,
    },
    {
      status: "failed",
      sub_title: 0,
      title: "Failed",
      active: false,
    },
  ]);
  const [statusActive, setStatusActive] = React.useState(0);
  const [openFormStart, setOpenFormStart] = React.useState(false);
  const [openFormComplete, setOpenFormComplete] = React.useState(false);
  const [formData, setFormData] = React.useState("");

  let tEnd = moment(new Date()).format("YYYY-MM-DD") + " 23:59:59";
  let tStart = moment(new Date()).format("YYYY-MM-DD") + " 00:00:00";
  const [dateRange, setDateRange] = React.useState({
    startDate: moment(tStart).tz("UTC").format(),
    endDate: moment(tEnd).tz("UTC").format(),
    key: "",
  });
  const [isLoading, setIsLoading] = React.useState(false);
  const [downloading, setDownloading] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [pageState, setPageState] = React.useState("");
  const [pageFilter, setPageFilter] = React.useState({
    num: 10,
    cursor:
      pageState?.headers && pageState?.headers["x-cursor"]
        ? pageState?.headers["x-cursor"]
        : "",
    keyword: search,
    date_start: dateRange.startDate,
    date_end: dateRange.endDate,
    progress:
      arrStatus[statusActive]?.status === "all"
        ? ""
        : arrStatus[statusActive]?.status,
  });
  const loadMoreBtnRef = React.useRef("");

  const chatToCustomer = React.useCallback((transaction_delivery) => {
    const transaction = transaction_delivery?.transaction;
    const delivery_group = transaction_delivery?.delivery_groups[0];
    const phone = `${transaction?.customer_address?.prefix_phone}${transaction?.customer_address?.consignee_phone}`;
    let message = `*${transaction?.unique_id}*%0a${transaction_delivery?.property?.name} - Delivery`;
    const url = `https://api.whatsapp.com/send?phone=${phone}&text=${message.replace(
      / /g,
      "%20"
    )}`;
    if (!window.open(url, "_blank")) {
      window.location.replace(url);
    }
  }, []);

  const toggleStatus = (index) => {
    setStatusActive(index);
    setPageFilter({
      ...pageFilter,
      cursor: "",
      progress:
        arrStatus[index]?.status === "all" ? "" : arrStatus[index]?.status,
    });
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleDateChange = (val) => {
    let endDate = moment(val.endDate).format("YYYY-MM-DD") + " 23:59:59";
    let tStart = moment(val.startDate).tz("UTC").format();
    let tEnd = moment(endDate).tz("UTC").format();
    setDateRange({
      startDate: tStart,
      endDate: tEnd,
      key: val.key,
    });
    setPageFilter({
      ...pageFilter,
      cursor: "",
      date_start: tStart,
      date_end: tEnd,
    });
  };

  const handleCloseFormStart = () => {
    setOpenFormStart(false);
    setFormData("");
  };

  const handleCloseFormComplete = () => {
    setOpenFormComplete(false);
    setFormData("");
  };

  const handleOpenFormStart = (delivery) => {
    setOpenFormStart(true);
    setFormData(delivery);
  };

  const handleOpenFormComplete = (delivery) => {
    setOpenFormComplete(true);
    setFormData(delivery);
  };

  const getListDeliveryGroups = useQuery(
    [" listDeliveryGroups", pageFilter],
    () => {
      setIsLoading(true);
      return TransactionDeliveryService.getTransactionDeliveryGroup(pageFilter)
        .then((res) => res)
        .catch((error) => {
          handleError(error);
        });
    },
    {
      cacheTime: 0,
      enabled: false,
      onSuccess: (data) => {
        const headers = data?.headers;
        const items = data?.data || [];
        const existingItems = pageState?.list || [];

        if (
          pageState?.config &&
          pageState?.config?.url &&
          pageState?.config?.url !== data?.config?.url &&
          items.length > 0
        ) {
          if (
            pageState?.headers &&
            pageState?.headers["x-cursor"] &&
            pageState?.headers["x-cursor"] !== headers["x-cursor"] &&
            pageFilter.cursor !== ""
          ) {
            setPageState({
              ...data,
              list: existingItems?.concat(items),
            });
          } else {
            setPageState({
              ...data,
              list: items,
            });
          }
        } else if (!pageState?.config) {
          setPageState({
            ...data,
            list: items,
          });
        } else {
          if (pageState?.data !== items) {
            setPageState({
              ...data,
              list: items,
            });
          }
        }
      },
      onSettled: (data) => {
        setIsLoading(false);
      },
    }
  );

  const getSummaryDeliveryGroups = useQuery(
    [" summaryDeliveryGroups", pageFilter],
    () => {
      return TransactionDeliveryService.getTransactionDeliveryGroupSummary(
        pageFilter
      )
        .then((res) => res)
        .catch((error) => {
          handleError(error);
        });
    },
    {
      cacheTime: 0,
      onSuccess: (data) => {
        const items = data?.data;

        const getTotalData = (status) => {
          const find = items?.find((item) => item.status === status);

          if (find) {
            return find.total_data;
          } else {
            return 0;
          }
        };

        const remapArrstatus = arrStatus?.map((item) => ({
          ...item,
          sub_title: getTotalData(item.status),
          active: getTotalData(item.status) > 0 ? true : false,
        }));

        setArrStatus(remapArrstatus);
        getListDeliveryGroups.refetch();
      },
    }
  );

  const handleLoadMore = () => {
    setPageFilter({
      ...pageFilter,
      cursor: pageState?.headers["x-cursor"],
    });
  };

  const downloadTransactionDelivery = useQuery(
    ["downloadTransactionDelivery", pageFilter],
    () => {
      return TransactionDeliveryService.downloadTransactionDelivery(
        pageFilter
      ).then((res) => res.data);
    },
    {
      cacheTime: 0,
      enabled: false,
      retry: false,
      onError: (err) => {
        handleError(err);
      },
      onSuccess: (data) => {
        var temp =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
          encodeURIComponent(data.content);
        var download = document.createElement("a");
        download.href = temp;
        download.download = data.file_name;
        document.body.appendChild(download);
        download.click();
        document.body.removeChild(download);
      },
    }
  );

  const handleDownloadTransactionOrder = () => {
    downloadTransactionDelivery.refetch();
  };

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      if (pageState !== "") {
        document.documentElement.scrollTo({
          left: 0,
          top:
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight,
          behavior: "smooth",
        });
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [pageState]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      setPageFilter({
        ...pageFilter,
        cursor: "",
        keyword: search,
      });
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <BaseLayout background="gray">
      <div className="row mx-0 w-100">
        <div className="col-12 px-0">
          <h3 className="font-16 font-bold mb-0">Order/Delivery</h3>
        </div>
        <div className="col-12 px-0">
          <div className="card rounded-8px border-0 mt-4">
            <div className="card-body border-0 px-4 pt-4 pb-0">
              <div className="w-100 d-flex flex-wrap justify-content-start align-items-center">
                <BootstrapInputSearch
                  placeholder="Search Transaction"
                  onChange={(e) => handleSearch(e)}
                />
                <DateRangePickerFilter
                  onChange={(val) => handleDateChange(val)}
                  defaultDate={dateRange}
                  maxDate={new Date()}
                  label="Lihat Transaksi:"
                  iconPosition="right"
                  style={
                    width === "lg" || width === "xl" || width === "md"
                      ? { marginLeft: 12 }
                      : { marginLeft: 0, marginTop: 12 }
                  }
                />
                {width !== "sm" && width !== "xs" && params.create && (
                  <button
                    type="button"
                    className="btn btn-blue font-bold ml-auto"
                    onClick={() => handleDownloadTransactionOrder()}
                    disabled={downloadTransactionDelivery.isLoading}
                  >
                    Export to excel
                  </button>
                )}
              </div>
              <p className="font-12 font-bold my-3">Status</p>
              <IzyTabsPanel
                tabs={arrStatus}
                tabActive={statusActive}
                onClick={(index) => toggleStatus(index)}
              />
            </div>
            <div className="card-body border-0 px-4 pt-0 pb-4">
              <TableContainer>
                <IZYTable>
                  <TableHead>
                    <IZYTableRow>
                      <IZYTableCell align="left" width="5%">
                        No
                      </IZYTableCell>
                      <IZYTableCell align="left" width="20%">
                        Name
                      </IZYTableCell>
                      <IZYTableCell align="left" width="10%">
                        Courier Vendor
                      </IZYTableCell>
                      <IZYTableCell align="left" width="15%">
                        Tenant
                      </IZYTableCell>
                      <IZYTableCell align="left" width="13%">
                        Billing
                      </IZYTableCell>
                      <IZYTableCell align="left" width="12%">
                        Date
                      </IZYTableCell>
                      <IZYTableCell align="left" width="25%"></IZYTableCell>
                    </IZYTableRow>
                  </TableHead>
                  <TableBody>
                    {!getListDeliveryGroups?.isLoading &&
                      !isLoading &&
                      getListDeliveryGroups?.isSuccess &&
                      pageState?.list?.length > 0 &&
                      pageState?.list?.map((transaction, key) => (
                        <ListRowPanel
                          status={arrStatus[statusActive]}
                          transaction_delivery={transaction}
                          key={key}
                          number={key + 1}
                          handleChat={chatToCustomer}
                          handleOpenFormStart={handleOpenFormStart}
                          handleOpenFormComplete={handleOpenFormComplete}
                          action={params}
                        />
                      ))}
                    {(getListDeliveryGroups?.isLoading || isLoading) &&
                      Array.from(new Array(5)).map((val, key) => (
                        <ListRowLoadingPanel key={key} />
                      ))}
                  </TableBody>
                </IZYTable>
              </TableContainer>
              {!getListDeliveryGroups?.isLoading &&
                !isLoading &&
                pageState?.headers &&
                pageState?.headers["x-cursor"] &&
                pageState?.headers["x-cursor"] !== "" &&
                arrStatus[statusActive].sub_title > pageState?.list?.length && (
                  <div className="w-100 text-center">
                    <button
                      type="button"
                      className="btn btn-blue px-3 mt-3"
                      onClick={() => handleLoadMore()}
                      ref={loadMoreBtnRef}
                    >
                      Load More
                    </button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      {(width === "sm" || width === "xs") && params.create && (
        <StyledFAB
          color="primary"
          onClick={() => handleDownloadTransactionOrder()}
          disabled={downloadTransactionDelivery.isLoading}
        >
          <ImportExportIcon />
        </StyledFAB>
      )}
      <FormStartDelivery
        isShow={openFormStart}
        onClose={handleCloseFormStart}
        refetch={() => getSummaryDeliveryGroups.refetch()}
        delivery={formData}
      />
      <FormCompleteDelivery
        isShow={openFormComplete}
        onClose={handleCloseFormComplete}
        refetch={() => getSummaryDeliveryGroups.refetch()}
        delivery={formData}
      />
    </BaseLayout>
  );
};

export default withWidth()(NewOrder);
